// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderDetails_container__6QbR3"};